import Vue from "vue";
import Router from "vue-router";
import JwtService from "@/common/jwt.service";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      redirect: "/dashboard",
      component: () => import("@/views/theme/Base"),
      beforeEnter: (to, from, next) => {
        // check user permissions
        if (to.meta.roles) {
          if (!JwtService.getUser()) {
            next({ path: "/login" });
          } else if (
            JwtService.getUser().role == "Hall" &&
            to.name !== "hallRoutemapActions"
          ) {
            next({ path: "/hall" });
          } else if (!to.meta.roles.includes(JwtService.getUser().role)) {
            next({ path: "/dashboard" });
          } else {
            next();
          }
        } else {
          next();
        }
      },
      children: [
        {
          path: "/dashboard",
          name: "dashboard",
          meta: {
            title: "HOME",
            roles: [
              "Admin",
              "Qualified",
              "Manager",
              "Labourer",
              "Quality Manager",
              "Hall"
            ]
          },
          component: () => import("@/views/pages/dashboard/Dashboard.vue")
        },
        {
          path: "/products",
          component: () => import("@/views/pages/products/Index"),
          meta: {
            roles: ["Admin", "Manager"],
            title: "PRODUCTS"
          },
          children: [
            {
              name: "productsList",
              path: "/",
              component: () => import("@/views/pages/products/List"),
              meta: {
                roles: ["Admin", "Manager"],
                title: "PRODUCTS"
              }
            },
            {
              name: "productsCreateUpdate",
              path: "add/:id?",
              component: () => import("@/views/pages/products/CreateUpdate"),
              meta: {
                roles: ["Admin", "Manager"],
                title: "EDIT_PRODUCT"
              }
            }
          ]
        },
        {
          path: "/raw-products",
          component: () => import("@/views/pages/raw_products/Index"),
          meta: {
            roles: ["Admin", "Qualified", "Manager"],
            title: "RAW_PRODUCTS"
          },
          children: [
            {
              name: "rawProductsList",
              path: "/",
              component: () => import("@/views/pages/raw_products/List"),
              meta: {
                roles: ["Admin", "Qualified", "Manager"],
                title: "RAW_PRODUCTS"
              }
            },
            {
              name: "rawProductsCreateUpdate",
              path: "add/:id?",
              component: () =>
                import("@/views/pages/raw_products/CreateUpdate"),
              meta: {
                roles: ["Admin", "Qualified", "Manager"],
                title: "EDIT_RAW_PRODUCT"
              }
            }
          ]
        },
        {
          path: "/materials",
          component: () => import("@/views/pages/materials/Index"),
          meta: {
            roles: ["Admin", "Quality Manager"],
            title: "MATERIALS"
          },
          children: [
            {
              name: "materialsList",
              path: "/",
              component: () => import("@/views/pages/materials/List"),
              meta: {
                roles: ["Admin", "Quality Manager"],
                title: "MATERIALS"
              }
            },
            {
              name: "materialsCreateUpdate",
              path: "add/:id?",
              component: () => import("@/views/pages/materials/CreateUpdate"),
              meta: {
                roles: ["Admin", "Quality Manager"],
                title: "EDIT_MATERIAL"
              }
            }
          ]
        },
        {
          path: "/material-properties",
          component: () => import("@/views/pages/material_properties/Index"),
          meta: {
            roles: ["Admin", "Quality Manager"],
            title: "MATERIAL_REQUIREMENTS"
          },
          children: [
            {
              name: "materialPropertiesList",
              path: "/",
              component: () => import("@/views/pages/material_properties/List"),
              meta: {
                roles: ["Admin", "Quality Manager"],
                title: "MATERIAL_REQUIREMENTS"
              }
            },
            {
              name: "materialPropertiesCreateUpdate",
              path: "add/:id?",
              component: () =>
                import("@/views/pages/material_properties/CreateUpdate"),
              meta: {
                roles: ["Admin", "Quality Manager"],
                title: "EDIT_MATERIAL_REQUIREMENT"
              }
            }
          ]
        },
        {
          path: "/vendors",
          component: () => import("@/views/pages/vendors/Index"),
          meta: {
            roles: ["Admin", "Qualified", "Quality Manager"],
            title: "VENDORS"
          },
          children: [
            {
              name: "vendorsList",
              path: "/",
              component: () => import("@/views/pages/vendors/List"),
              meta: {
                roles: ["Admin", "Qualified", "Quality Manager"],
                title: "VENDORS"
              }
            },
            {
              name: "vendorsCreateUpdate",
              path: "add/:id?",
              component: () => import("@/views/pages/vendors/CreateUpdate"),
              meta: {
                roles: ["Admin", "Qualified", "Quality Manager"],
                title: "EDIT_VENDOR"
              }
            }
          ]
        },
        {
          path: "/printing-houses",
          component: () => import("@/views/pages/printingHouses/Index"),
          meta: {
            roles: ["Admin", "Quality Manager"],
            title: "PRINTING_HOUSES"
          },
          children: [
            {
              name: "printingHousesList",
              path: "/",
              component: () => import("@/views/pages/printingHouses/List"),
              meta: {
                roles: ["Admin", "Quality Manager"],
                title: "PRINTING_HOUSES"
              }
            },
            {
              name: "printingHousesCreateUpdate",
              path: "add/:id?",
              component: () =>
                import("@/views/pages/printingHouses/CreateUpdate"),
              meta: {
                roles: ["Admin", "Quality Manager"],
                title: "EDIT_PRINTING_HOUSE"
              }
            }
          ]
        },

        {
          path: "/clients",
          component: () => import("@/views/pages/clients/Index"),
          meta: {
            roles: ["Admin", "Manager"],
            title: "CLIENTS"
          },
          children: [
            {
              name: "clientsList",
              path: "/",
              component: () => import("@/views/pages/clients/List"),
              meta: {
                roles: ["Admin", "Manager"],
                title: "CLIENTS"
              }
            },
            {
              name: "clientsCreateUpdate",
              path: "add/:id?",
              component: () => import("@/views/pages/clients/CreateUpdate"),
              meta: {
                roles: ["Admin", "Manager"],
                title: "EDIT_CLIENT"
              }
            }
          ]
        },
        {
          path: "/operators",
          component: () => import("@/views/pages/operators/Index"),
          meta: {
            roles: ["Admin", "Manager"],
            title: "OPERATORS"
          },
          children: [
            {
              name: "operatorsList",
              path: "/",
              component: () => import("@/views/pages/operators/List"),
              meta: {
                roles: ["Admin", "Manager"],
                title: "OPERATORS"
              }
            },
            {
              name: "operatorsCreateUpdate",
              path: "add/:id?",
              component: () => import("@/views/pages/operators/CreateUpdate"),
              meta: {
                roles: ["Admin", "Manager"],
                title: "EDIT_OPERATOR"
              }
            },
            {
              name: "operatorsHolidays",
              path: "holidays/:id",
              component: () => import("@/views/pages/operators/Holidays"),
              meta: {
                roles: ["Admin", "Manager"],
                title: "OPERATOR_HOLIDAYS"
              }
            }
          ]
        },
        {
          path: "/warehouses",
          component: () => import("@/views/pages/warehouses/Index"),
          meta: {
            roles: ["Admin", "Manager"],
            title: "WAREHOUSES"
          },
          children: [
            {
              name: "warehousesList",
              path: "/",
              component: () => import("@/views/pages/warehouses/List"),
              meta: {
                roles: ["Admin", "Manager"],
                title: "WAREHOUSES"
              }
            },
            {
              name: "warehousesCreateUpdate",
              path: "add/:id?",
              component: () => import("@/views/pages/warehouses/CreateUpdate"),
              meta: {
                roles: ["Admin", "Manager"],
                title: "EDIT_WAREHOUSE"
              }
            }
          ]
        },
        {
          path: "/users",
          component: () => import("@/views/pages/users/Index"),
          meta: {
            roles: ["Admin"],
            title: "USERS"
          },
          children: [
            {
              name: "usersList",
              path: "/",
              component: () => import("@/views/pages/users/List"),
              meta: {
                roles: ["Admin"],
                title: "USERS"
              }
            },
            {
              name: "usersCreateUpdate",
              path: "add/:id?",
              component: () => import("@/views/pages/users/CreateUpdate"),
              meta: {
                roles: ["Admin"],
                title: "EDIT_USER"
              }
            }
          ]
        },
        {
          path: "/profile",
          component: () => import("@/views/pages/users/Index"),
          meta: {
            roles: [
              "Admin",
              "Manager",
              "Hall",
              "Labourer",
              "Qualified",
              "Quality Manager"
            ],
            title: "PROFILE"
          },
          children: [
            {
              name: "editProfile",
              path: "/",
              component: () => import("@/views/pages/users/UpdateProfile"),
              meta: {
                roles: [
                  "Admin",
                  "Manager",
                  "Hall",
                  "Labourer",
                  "Qualified",
                  "Quality Manager"
                ],
                title: "PROFILE"
              }
            }
          ]
        },
        {
          path: "/material-request",
          component: () => import("@/views/pages/material_request/Index"),
          meta: {
            roles: ["Admin", "Manager"],
            title: "MATERIAL_REQUEST"
          },
          children: [
            {
              name: "materialRequestList",
              path: "/",
              component: () => import("@/views/pages/material_request/List"),
              meta: {
                roles: ["Admin", "Manager"],
                title: "MATERIAL_REQUEST"
              }
            },
            {
              name: "materialRequestCreateUpdate",
              path: "add/:id?",
              component: () =>
                import("@/views/pages/material_request/CreateUpdate"),
              meta: {
                roles: ["Admin", "Manager"],
                title: "EDIT_MATERIAL_REQUEST"
              }
            }
          ]
        },
        {
          path: "/certificates",
          component: () => import("@/views/pages/certificates/Index"),
          meta: {
            roles: ["Admin", "Qualified", "Quality Manager"],
            title: "CERTIFICATE_OF_RELEASE_OF_PACKAGING_MATERIALS"
          },
          children: [
            {
              name: "certificatesList",
              path: "/",
              component: () => import("@/views/pages/certificates/List"),
              meta: {
                roles: ["Admin", "Qualified", "Quality Manager", "Manager"],
                title: "CERTIFICATE_OF_RELEASE_OF_PACKAGING_MATERIALS"
              }
            },
            {
              name: "certificatesCreateUpdate",
              path: "add/:id?",
              component: () =>
                import("@/views/pages/certificates/CreateUpdate"),
              meta: {
                roles: ["Admin", "Qualified", "Quality Manager"],
                title:
                  "EDIT_CERTIFICATE_OF_RELEASE_OF_PACKAGING_MATERIALS"
              }
            }
          ]
        },
        {
          path: "/destruction-packaging-materials",
          component: () =>
            import("@/views/pages/destruction_packaging_materials/Index"),
          meta: {
            roles: ["Admin", "Quality Manager"],
            title: "DESTRUCTION_PROTOCOL_OF_SECONDARY_PACKAGING_MATERIALS"
          },
          children: [
            {
              name: "destructionPackagingMaterialList",
              path: "/",
              component: () =>
                import("@/views/pages/destruction_packaging_materials/List"),
              meta: {
                roles: ["Admin", "Quality Manager"],
                title:
                  "DESTRUCTION_PROTOCOL_OF_SECONDARY_PACKAGING_MATERIALS"
              }
            },
            {
              name: "destructionPackagingMaterialCreateUpdate",
              path: "add/:id?",
              component: () =>
                import(
                  "@/views/pages/destruction_packaging_materials/CreateUpdate"
                ),
              meta: {
                roles: ["Admin", "Quality Manager"],
                title:
                  "EDIT_DESTRUCTION_PROTOCOL_OF_SECONDARY_PACKAGING_MATERIALS"
              }
            }
          ]
        },
        {
          path: "/invoices",
          component: () => import("@/views/pages/invoices/Index"),
          meta: {
            roles: ["Admin", "Manager", "Quality Manager"],
            title: "INVOICES"
          },
          children: [
            {
              name: "invoicesList",
              path: "/",
              component: () => import("@/views/pages/invoices/List"),
              meta: {
                roles: ["Admin", "Manager", "Quality Manager"],
                title: "INVOICES"
              }
            },
            {
              name: "invoicesCreateUpdate",
              path: "add/:id?",
              component: () => import("@/views/pages/invoices/CreateUpdate"),
              meta: {
                roles: ["Admin", "Manager", "Quality Manager"],
                title: "EDIT_INVOICE"
              }
            }
          ]
        },
        {
          name: "statistics",
          path: "/statistics",
          component: () => import("@/views/pages/statistics/Index"),
          meta: {
            roles: ["Admin", "Qualified", "Manager", "Quality Manager"],
            title: "STATISTICS"
          },
          children: [
            {
              name: "quantityInStock",
              path: "quantity-in-stock",
              component: () =>
                import("@/views/pages/statistics/QuantityInStock"),
              meta: {
                roles: ["Admin", "Qualified", "Manager", "Quality Manager"],
                title: "QUANTITY_IN_STOCK"
              }
            },
            {
              name: "normsStatistics",
              path: "norms",
              component: () => import("@/views/pages/statistics/Norms"),
              meta: {
                roles: ["Admin", "Manager"],
                title: "NORMS"
              }
            }
          ]
        },
        {
          name: "settings",
          path: "/settings",
          component: () => import("@/views/pages/settings/Index"),
          meta: {
            roles: ["Admin"],
            title: "SETTINGS"
          },
          children: [
            {
              name: "workBreakList",
              path: "work-breaks",
              component: () => import("@/views/pages/settings/WorkBreakList"),
              meta: {
                roles: ["Admin"],
                title: "WORK_BREAKS"
              }
            },
            {
              name: "workBreakCreateUpdate",
              path: "work-breaks/add/:id?",
              component: () =>
                import("@/views/pages/settings/WorkBreakCreateUpdate"),
              meta: {
                roles: ["Admin"],
                title: "EDIT_WORK_BREAK"
              }
            },
            {
              name: "workingTime",
              path: "working-time",
              component: () =>
                import("@/views/pages/settings/WorkingTimeUpdate"),
              meta: {
                roles: ["Admin"],
                title: "WORKING_TIME"
              }
            }
          ]
        },
        {
          path: "/scrap-register",
          component: () => import("@/views/pages/register/scrap/Index"),
          meta: {
            roles: ["Admin", "Qualified", "Manager", "Quality Manager"],
            title: "SCRAP_REGISTER"
          },
          children: [
            {
              name: "scrapRegisterList",
              path: "/",
              component: () => import("@/views/pages/register/scrap/List"),
              meta: {
                roles: ["Admin", "Qualified", "Manager", "Quality Manager"],
                title: "SCRAP_REGISTER"
              }
            }
          ]
        },
        {
          path: "/sample-register",
          component: () => import("@/views/pages/register/sample/Index"),
          meta: {
            roles: ["Admin", "Qualified", "Manager", "Quality Manager"],
            title: "SAMPLE_REGISTER"
          },
          children: [
            {
              name: "sampleRegisterList",
              path: "/",
              component: () => import("@/views/pages/register/sample/List"),
              meta: {
                roles: ["Admin", "Qualified", "Manager", "Quality Manager"],
                title: "SAMPLE_REGISTER"
              }
            }
          ]
        },
        {
          path: "/final-product-sale",
          component: () => import("@/views/pages/register/sample/Index"),
          meta: {
            roles: ["Admin", "Qualified", "Manager", "Quality Manager"],
            title: "CERTIFICATE_OF_RELEASE_FOR_SALE_OF_FINAL_PRODUCT"
          },
          children: [
            {
              name: "finalProductSaleRegisterList",
              path: "/",
              component: () =>
                import("@/views/pages/register/final_product_sale/List"),
              meta: {
                roles: ["Admin", "Qualified", "Manager", "Quality Manager"],
                title: "CERTIFICATE_OF_RELEASE_FOR_SALE_OF_FINAL_PRODUCT"
              }
            }
          ]
        },
        {
          path: "/emails",
          component: () => import("@/views/pages/emails/Index"),
          meta: {
            roles: ["Admin"],
            title: "EMAILS"
          },
          children: [
            {
              name: "emailsList",
              path: "/",
              component: () => import("@/views/pages/emails/List"),
              meta: {
                roles: ["Admin"],
                title: "EMAILS"
              }
            },
            {
              name: "emailsCreateUpdate",
              path: "add/:id?",
              component: () => import("@/views/pages/emails/CreateUpdate"),
              meta: {
                roles: ["Admin"],
                title: "EDIT_EMAIL"
              }
            }
          ]
        },
        {
          path: "/load",
          component: () => import("@/views/pages/load/Index"),
          meta: {
            roles: ["Labourer"],
            title: "ROUTE_MAPS_FOR_LOADING"
          },
          children: [
            {
              name: "loadList",
              path: "/",
              component: () => import("@/views/pages/load/List"),
              meta: {
                roles: ["Labourer"],
                title: "ROUTE_MAPS_FOR_LOADING"
              }
            }
          ]
        },
        {
          name: "logs",
          path: "/logs",
          component: () => import("@/views/pages/logs/Index"),
          meta: {
            roles: ["Admin", "Qualified", "Manager", "Quality Manager"],
            title: "LOGS"
          },
          children: [
            {
              name: "logsList",
              path: ":type/:id/:group?",
              component: () => import("@/views/pages/logs/List"),
              meta: {
                roles: ["Admin", "Qualified", "Manager", "Quality Manager"],
                title: "LOGS"
              }
            }
          ]
        },
        {
          name: "routemaps",
          path: "/routemaps",
          component: () => import("@/views/pages/routemaps/Index"),
          meta: {
            roles: ["Admin", "Qualified", "Manager", "Quality Manager"],
            title: "ROUTE_MAP"
          },
          children: [
            {
              name: "routemapsListNew",
              path: "new",
              component: () => import("@/views/pages/routemaps/ListNew"),
              meta: {
                roles: ["Admin", "Qualified", "Manager", "Quality Manager"],
                title: "NEW_ROUTE_MAPS"
              }
            },
            {
              name: "routemapsList",
              path: "list",
              component: () => import("@/views/pages/routemaps/List"),
              meta: {
                roles: ["Admin", "Qualified", "Manager", "Quality Manager"],
                title: "CURRENT_ROUTE_MAPS"
              }
            },
            {
              name: "routemapsActions",
              path: "view/:id?",
              component: () => import("@/views/pages/routemaps/Actions"),
              meta: {
                roles: ["Admin", "Qualified", "Manager", "Quality Manager"],
                title: "ROUTE_MAP_OPERATIONS"
              }
            },
            {
              name: "routemapsCreateUpdate",
              path: "add/:id?",
              component: () => import("@/views/pages/routemaps/CreateUpdate"),
              meta: {
                roles: ["Admin", "Manager"],
                title: "EDIT_ROUTE_MAP"
              }
            },
            {
              name: "routemapsListDone",
              path: "done",
              component: () => import("@/views/pages/routemaps/ListDone"),
              meta: {
                roles: ["Admin", "Qualified", "Manager", "Quality Manager"],
                title: "DONE_ROUTE_MAPS"
              }
            }
          ]
        },
        {
          path: "/halls",
          component: () => import("@/views/pages/hall/Index"),
          meta: {
            roles: ["Admin", "Manager"],
            title: "HALLS"
          },
          children: [
            {
              name: "hallsList",
              path: "/",
              component: () => import("@/views/pages/hall/List"),
              meta: {
                roles: ["Admin", "Manager"],
                title: "HALLS"
              }
            },
            {
              name: "hallsCreateUpdate",
              path: "add/:id?",
              component: () => import("@/views/pages/hall/CreateUpdate"),
              meta: {
                roles: ["Admin", "Manager"],
                title: "EDIT_HALL"
              }
            }
          ]
        }
      ]
    },
    {
      path: "/hall",
      component: () => import("@/views/pages/hall/Index"),
      beforeEnter: (to, from, next) => {
        // check user permissions
        if (to.meta.roles) {
          if (!JwtService.getUser()) {
            next({ path: "/login" });
          } else if (!to.meta.roles.includes(JwtService.getUser().role)) {
            next({ path: "/dashboard" });
          } else {
            next();
          }
        } else {
          next();
        }
      },
      meta: {
        roles: ["Hall"],
        title: "ROUTE_MAP_OPERATIONS"
      },
      children: [
        {
          name: "hallRoutemapActions",
          path: "/",
          component: () => import("@/views/pages/hall/RoutemapActions"),
          meta: {
            roles: ["Hall"],
            title: "ROUTE_MAP_OPERATIONS"
          }
        }
      ]
    },
    {
      path: "/",
      component: () => import("@/views/pages/auth/Auth"),
      children: [
        {
          name: "login",
          path: "/login",
          meta: {
            title: "LOGIN"
          },
          component: () => import("@/views/pages/auth/Login")
        },
        {
          name: "twoFactor",
          path: "/login/2",
          component: () => import("@/views/pages/auth/TwoFactor"),
          meta: {
            title: "TWO_FACTOR_AUTHENTICATION"
          }
        },
        {
          name: "register",
          path: "/register",
          component: () => import("@/views/pages/auth/Register"),
          meta: {
            title: "REGISTRATION"
          }
        },
        {
          name: "forgot",
          path: "/forgot",
          component: () => import("@/views/pages/auth/Forgot"),
          meta: {
            title: "FORGOTTEN_PASSWORD"
          }
        },
        {
          name: "reset",
          path: "/reset/:token/:email",
          component: () => import("@/views/pages/auth/Reset"),
          meta: {
            title: "RESET_PASSWORD"
          }
        }
      ]
    },
    {
      path: "*",
      redirect: "/404"
    },
    {
      // the 404 route, when none of the above matches
      path: "/404",
      name: "404",
      component: () => {
        return import("@/views/pages/error/Error-1.vue");
      }
    }
  ]
});
